import React from 'react';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Register from './components/Auth/Register';
import Login from './components/Auth/Login';
import CalculatorForm from './components/Calculator/CalculatorForm';
import CalculationHistory from './components/History/CalculationHistory';
import Navbar from './components/Layout/Navbar';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import ParametrosForm from './components/Configuration/ParametrosForm';
import LoteCalculator from './components/Map/LoteCalculator';
import ProfilePage from './components/Profile/ProfilePage';

class ErrorBoundary extends React.Component {
    constructor(props) { super(props); this.state = { hasError: false, error: null }; }
    static getDerivedStateFromError(error) { return { hasError: true, error }; }
    render() {
        if (this.state.hasError) {
            return (
                <div style={{ padding: '40px', textAlign: 'center' }}>
                    <h3>Algo deu errado.</h3>
                    <p style={{ color: '#666' }}>{this.state.error?.message}</p>
                    <button onClick={() => window.location.reload()} style={{ padding: '8px 20px', cursor: 'pointer' }}>
                        Recarregar
                    </button>
                </div>
            );
        }
        return this.props.children;
    }
}

const PrivateRoute = ({ children }) => {
    const { isAuthenticated, loading } = useAuth();
    if (loading) {
        return <div>Carregando...</div>; // Ou um spinner de carregamento
    }
    return isAuthenticated ? children : <Navigate to="/login" />;
};

function App() {
    return (
        <Router>
            <Navbar />
            <div className="container mt-4">
                <Routes>
                    <Route path="/register" element={<Register />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/" element={<Navigate to="/calculate" />} /> {/* Redireciona para /calculate */}
                    <Route
                        path="/calculate"
                        element={
                            <PrivateRoute>
                                <CalculatorForm />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/history"
                        element={
                            <PrivateRoute>
                                <CalculationHistory />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/lote"
                        element={
                            <PrivateRoute>
                                <LoteCalculator />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/parametros"
                        element={
                            <PrivateRoute>
                                <ParametrosForm />
                            </PrivateRoute>
                        }
                    />
                    <Route
                        path="/profile"
                        element={
                            <PrivateRoute>
                                <ProfilePage />
                            </PrivateRoute>
                        }
                    />
                </Routes>
            </div>
        </Router>
    );
}

const AppWrapper = () => (
    <ErrorBoundary>
        <AuthProvider>
            <App />
        </AuthProvider>
    </ErrorBoundary>
);

export default AppWrapper;